export const setSessionStorage = (key, value) => {
  if (!key || !value) return
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  window.sessionStorage.setItem('kaibuy_store_' + key, value)
}

export const getSessionStorage = key => {
  if (!key) return
  return window.sessionStorage.getItem('kaibuy_store_' + key) || null
}

export const removeSessionStorage = key => {
  if (!key) return
  window.sessionStorage.removeItem('kaibuy_store_' + key)
}

export const setLocalStorage = (key, value) => {
  if (!key || !value) return
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem('kaibuy_store_' + key, value)
}

export const getLocalStorage = key => {
  if (!key) return
  return window.localStorage.getItem('kaibuy_store_' + key) || null
}

export const removeLocalStorage = key => {
  if (!key) return
  window.localStorage.removeItem('kaibuy_store_' + key)
}



// WEBPACK FOOTER //
// ./src/utils/storage.js